import Grid from '@mui/material/Grid';

import JoinTheWaitlist from 'reservations/availabilities/components/JoinTheWaitlist';
import AddToWaitlistButton from 'reservations/form/components/AddToWaitlistButton';
import { DinerAuthenticationFields } from 'reservations/form/components/DinerAuthenticationFields';
import MarketingOptIn from 'reservations/form/components/MarketingOptIn';

export const WaitlistFields = () => {
  return (
    <>
      <Grid item>
        <JoinTheWaitlist />
      </Grid>
      <DinerAuthenticationFields />
      <Grid item sx={{ mb: '-4px' }}>
        <MarketingOptIn />
      </Grid>
      <Grid item>
        <AddToWaitlistButton />
      </Grid>
    </>
  );
};
